import { useTheme } from '@emotion/react';
import { ArrowBackIos, ArrowForwardIos, Download } from '@mui/icons-material';
import { Box, Button, IconButton, Typography, useMediaQuery } from '@mui/material';
import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import { Document, Page, pdfjs } from 'react-pdf';
import { Link } from 'react-router-dom';

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

export default function MaterialPDF(props) {

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'));
    const isSuperSmall = useMediaQuery('(max-width:350px)')
    const {t} = useTranslation()

    const width = isXs ? 280 : 420;

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    function nextPage() {
        if (pageNumber < numPages) {
            setPageNumber(pageNumber+1);
        }
    }

    function prevPage() {
        if (pageNumber > 1) {
            setPageNumber(pageNumber-1);
        }
    }

    return(
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", m: 2}}>
            <Typography variant="h1">{props.title}</Typography>
            <Typography sx={{mt: 2}}>{props.description}</Typography>
            <Box sx={{m: 2}}>
                <Link to={props.doc} target="_blank" download>
                    <Button variant="contained" endIcon=<Download/>>Download</Button>
                </Link> 
            </Box>
            <Typography>{t("materialPreview")}:</Typography>
            <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", mt: 2}}>
            {
                !isSuperSmall &&
                <IconButton disabled={pageNumber===1} onClick={prevPage}><ArrowBackIos/></IconButton>
            }
                <Document file={props.doc} onLoadSuccess={onDocumentLoadSuccess}>
                    <Page pageNumber={pageNumber} width={width} renderAnnotationLayer={false} renderTextLayer={false}/>
                </Document>
                {
                    !isSuperSmall &&
                    <IconButton disabled={pageNumber===numPages} onClick={nextPage}><ArrowForwardIos/></IconButton>
                }
            </Box>
        </Box>
    )
}